module.exports = __webpack_public_path__ + "static/media/world-thai-chi.df1b18be.vtt";